export default __webpack_public_path__ + "static/media/copySvg.fa6d6d64.svg";